






















































// --- Vue & Template imports ---
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import BaseMaterialCard from '@/components/base/MaterialCard.vue';
import ReturnForm from './components/ReturnForm.vue';

// --- Models ---

// --- Services ---
import WaybillService from '@/services/waybill';

// --- Third Party imports ---

@Component({
  components: {
    BaseMaterialCard,
    ReturnForm,
  },
})
export default class LogReturnPage extends Vue {
  styleMe: boolean = true;

  async beforeMount() {
    this.styleMe = this.$route.meta.styled;

    await WaybillService.getMyWaybill(false);
  }


}
